const Resources = {

    table_headers: [
        {
            text: '#Room',
            value: 'door_number'
        },
        {
            text: 'Description',
            value: 'custom_description'
        },
        {
            text: 'Task',
            value: 'task'
        },
        {
            text: 'Daily Min',
            value: 'room_task_minutes'
        },
        {
            text: 'Annual Min',
            value: 'annual_minutes'
        },
        {
            text: 'Frequency',
            value: 'frequency'
        },
        {
            text: 'SQ ft',
            value: 'sq_ft'
        },
        {
            text: 'Group',
            value: 'work_group'
        },
    ],

    filter_options:
    {
        show_properly_assigned_rooms: false,
        show_daily_assignment_filter: false,
        show_rooms_that_are: false,
    },
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Budgeting',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Staffing Scenarios',
            href:   `/budgeting-staffing-scenario`,
            arrow:  "<span class='slash'>/</span>",
        },
    ],

    boolean_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    excl_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    freq_options:[
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],

}

export default Resources;